import { Component, Input } from '@angular/core';
import { CellConfigInterface } from '../../models/cell-config.interface';

@Component({
  selector: 'twaice-fe-datatable-text-cell',
  templateUrl: './text-cell.component.html',
  standalone: false,
})
export class TextCellComponent {
  @Input() data: CellConfigInterface;
}
